// Every screen in the Hub spec (SCREEN-SPECS.md), synced by scripts/sync-screens.mjs.
import data from "./screens.json";

export interface Screen {
  id: string;
  title: string;
  domain: string;
  route: string | null;
  archetype: string;
  phase: string;
  who: string | null;
  purpose: string | null;
  loads: string | null;
  operations: { method: string; path: string; summary: string }[];
}

export const SCREENS = data.screens as Screen[];
export const SCREENS_BY_ID = new Map(SCREENS.map((s) => [s.id, s]));

/** Screens that are pages (not overlays such as the command palette). */
export const ROUTED_SCREENS = SCREENS.filter((s) => s.route?.startsWith("/"));

export const AUTH_SCREEN_IDS = new Set(SCREENS.filter((s) => s.domain === "D1").map((s) => s.id));

const matchers = ROUTED_SCREENS.map((s) => ({
  screen: s,
  re: new RegExp(`^${s.route!.replace(/:[A-Za-z]+/g, "[^/]+")}/?$`),
  // Static segments rank above parameters, as in the router.
  rank: s.route!.split("/").filter((p) => p && !p.startsWith(":")).length,
}));

/** The spec screen for a pathname, for contextual help. */
export function screenForPath(pathname: string): Screen | null {
  const hits = matchers.filter((m) => m.re.test(pathname)).sort((a, b) => b.rank - a.rank);
  return hits[0]?.screen ?? null;
}

export const DOMAIN_NAMES: Record<string, string> = {
  D1: "Sign-in & Identity",
  D2: "Account & Security",
  D3: "My Apps",
  D4: "Settings",
  D5: "Organizations",
  D6: "Users",
  D7: "Access",
  D8: "Roles & Permissions",
  D9: "Applications",
  D10: "Developer credentials",
  D11: "Plan & Billing",
  D12: "Audit Log",
  D13: "Notifications",
  G: "Shell",
  C: "Console",
};
